module.exports = __webpack_public_path__ + "img/app5.b9fd919c.jpg";